export default "__VITE_ASSET__CZXKCmNm__"